<template>
  <div
    ref="container"
    :class="{ 'personal-vacation vacation-past': true, active: active }"
  >
    <div class="vacation-card">
      <div class="vacation-title">
        <div class="vacation-icon">
          <i class="icon icon-airplane-blue"></i>
        </div>
        {{ $t("חבילה") }}&nbsp;&nbsp;{{ vacation.site.name }}
      </div>

      <div class="vacation-body">
        <ul class="vacation-accordion">
          <li :class="{ active: isTabActive(0) }" id="vacation-accordion-tab-0">
            <a href="#" @click.prevent="toggleTab(0)">
              <span>{{ $t("פרטי הטיסה") }}</span>
              <i class="icon icon-chevron-down-black"></i>
            </a>
            <transition name="fade">
              <div class="vacation-accordion-content">
                <ul class="vacation-flights">
                  <VacationFlight
                    :flight="vacation.flights.leave"
                    :summary="vacation.reservation_summary_link"
                    type="leave"
                  />
                  <VacationFlight
                    :flight="vacation.flights.return"
                    type="return"
                  />
                </ul>
              </div>
            </transition>
          </li>

          <li :class="{ active: isTabActive(1) }" id="vacation-accordion-tab-1">
            <a href="#" @click.prevent="toggleTab(1)">
              <span>{{ $t("פרטי המלון") }}</span>
              <i class="icon icon-chevron-down-black"></i>
            </a>
            <transition name="fade">
              <div
                class="vacation-accordion-content vacation-accordion-short padding"
              >
                <VacationHotel :hotel="vacation.hotel" />
              </div>
            </transition>
          </li>

          <li :class="{ active: isTabActive(2) }" id="vacation-accordion-tab-2">
            <a href="#" @click.prevent="toggleTab(2)">
              <span>{{ $t("פרטי שירותי הסקי") }}</span>
              <i class="icon icon-chevron-down-black"></i>
            </a>
            <transition name="fade">
              <div
                class="vacation-accordion-content vacation-accordion-content-services padding"
              >
                <VacationServices
                  :services="vacation.services"
                  :vacation="vacation"
                />
              </div>
            </transition>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import VacationFlight from "./VacationFlight.vue";
import VacationServices from "./VacationServices.vue";
import VacationHotel from "./VacationHotel.vue";

export default {
  components: {
    VacationFlight,
    VacationServices,
    VacationHotel,
  },

  props: {
    vacation: {
      type: Object,
      default: {},
    },
    active: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      accordion: {},
    };
  },

  methods: {
    toggleTab(index, noEmit) {
      const active = !this.isTabActive(index);
      this.$set(this.accordion, index, active);

      // Slide up/down animation.
      const $content = $(
        " #vacation-accordion-tab-" + index + " .vacation-accordion-content",
        this.$refs.container
      );
      if (this.isTabActive(index)) {
        $content.stop().slideDown(300);
      } else {
        $content.stop().slideUp(300);
      }

      if (!noEmit) {
        // Notify parent Vacations component.
        const isAnythingActive = Object.values(this.accordion).some((x) => x);
        this.$emit("change", isAnythingActive);
      }
    },

    isTabActive(index) {
      return this.accordion[index] || false;
    },
  },

  watch: {
    active(now) {
      if (!now) {
        for (let index in this.accordion) {
          if (this.isTabActive(index)) {
            this.toggleTab(index, true);
          }
        }
      }
    },
  },
};
</script>
